type Language = 'en' | 'es' | 'ru' | 'hy' | 'de' | 'fr' | 'it'

type Translations = {
    [key in Language]: {
        /** Слоганы заголовка: сменяют друг друга, первый — основной (его
         *  видят поисковики в готовом HTML). */
        bannerTitles: string[]
        /** Строка над заголовком: что это за продукт. */
        bannerEyebrow: string
        /** Вторая ссылка рядом с кнопкой — к видео о работе системы. */
        bannerSecondary: string
        bannerText: string
        /** Строка под кнопкой: сколько стоит. */
        bannerNote: string
        videoLinks: string[]
    }
}
export const translations: Translations = {
    en: {
        bannerEyebrow: 'A complete trading automation system',
        bannerSecondary: 'See how it works',
        bannerTitles: [
            'Automated futures trading on your own exchange account',
            'Your account, your money, your rules. The system works for you',
            'We don’t manage other people’s accounts. We build the tool',
            'All of your trading automation in one system',
            'You start it and you stop it. The system executes',
            'Futures trading 24/7, with no withdrawal access',
            'A tool for traders, not asset management',
            'We develop the system. You do the trading',
        ],
        bannerText:
            'RealColibri works with Binance, Bybit, OKX and CME. You connect your own account and stay in control: we never take funds under management and have no withdrawal rights.',
        bannerNote: 'Free to connect. Commission only on profitable trades.',
        videoLinks: [
            'https://www.youtube.com/embed/zScTMj_z_-w?si=hyKz1C4vWmxuC5By',
            'https://www.youtube.com/embed/s7svSzLdEyw',
            'https://www.youtube.com/embed/ELBK94vzhbE?si=faEYWsRjLcECsKgt',
            'https://www.youtube.com/embed/wU7khM9LyOE?si=url81iqegwAWe4AR',
        ],
    },
    es: {
        bannerEyebrow: 'Un sistema completo de automatización del trading',
        bannerSecondary: 'Cómo funciona',
        bannerTitles: [
            'Trading automático de futuros en su propia cuenta de exchange',
            'Su cuenta, su dinero, sus reglas. El sistema trabaja para usted',
            'No gestionamos cuentas ajenas. Creamos la herramienta',
            'Toda la automatización de su trading en un solo sistema',
            'Usted lo inicia y usted lo detiene. El sistema ejecuta',
            'Trading de futuros 24/7, sin acceso a retiros',
            'Una herramienta para traders, no gestión de activos',
            'Nosotros desarrollamos el sistema. Usted opera',
        ],
        bannerText:
            'RealColibri funciona con Binance, Bybit, OKX y CME. Usted conecta su propia cuenta y mantiene el control: no gestionamos fondos ni tenemos permiso de retiro.',
        bannerNote: 'Conexión gratuita. Comisión solo sobre operaciones con beneficio.',
        videoLinks: [
            'https://www.youtube.com/embed/s8DSKmVPqiQ?si=EYfMONdFjtcxTnNy',
            'https://www.youtube.com/embed/6REaGdn2TQs',
            'https://www.youtube.com/embed/_anbLWfMH4U?si=bN_5wcjZ9u8j2Hs3',
            'https://www.youtube.com/embed/S3VbGCGLV54?si=1n-OibacaEkO3gQ4',
        ],
    },
    ru: {
        bannerEyebrow: 'Готовая система автоматизации торговли',
        bannerSecondary: 'Как это работает',
        bannerTitles: [
            'Автоматическая торговля фьючерсами на вашем счёте',
            'Ваш счёт, ваши деньги, ваши правила. Система работает на вас',
            'Мы не управляем чужими счетами. Мы создаём инструмент',
            'Вся автоматизация торговли в одной системе',
            'Запускаете и останавливаете сами. Система исполняет',
            'Торговля фьючерсами 24/7 без доступа к выводу средств',
            'Инструмент для трейдера, а не доверительное управление',
            'Мы развиваем систему. Торгуете вы',
        ],
        bannerText:
            'RealColibri работает с Binance, Bybit, OKX и CME. Вы подключаете свой счёт и управляете всем сами: мы не берём средства в управление и не имеем права вывода.',
        bannerNote: 'Подключение бесплатно. Комиссия — только с прибыльных сделок.',
        videoLinks: [
            'https://www.youtube.com/embed/t3ISFTOnJhI?si=tmnBspc3vAUAsUIp',
            'https://www.youtube.com/embed/WMmyt_lemzU',
            'https://www.youtube.com/embed/0otw6OR-aPw?si=OTFt-pSwlBrHJLzH',
            'https://www.youtube.com/embed/GC9aQbUuSNc?si=7ViVrFvtS9zLapiz',
        ],
    },
    hy: {
        bannerEyebrow: 'Առևտրի ավտոմատացման պատրաստի համակարգ',
        bannerSecondary: 'Ինչպես է աշխատում',
        bannerTitles: [
            'Ֆյուչերսների ավտոմատ առևտուր ձեր սեփական բորսային հաշվում',
            'Ձեր հաշիվը, ձեր գումարը, ձեր կանոնները։ Համակարգն աշխատում է ձեզ համար',
            'Մենք չենք կառավարում ուրիշների հաշիվները։ Մենք ստեղծում ենք գործիքը',
            'Առևտրի ողջ ավտոմատացումը մեկ համակարգում',
            'Դուք եք գործարկում և դուք եք կանգնեցնում։ Համակարգը կատարում է',
            'Ֆյուչերսների առևտուր 24/7՝ առանց դուրսբերման հասանելիության',
            'Գործիք թրեյդերի համար, ոչ թե ակտիվների կառավարում',
            'Մենք զարգացնում ենք համակարգը։ Առևտուրն անում եք դուք',
        ],
        bannerText:
            'RealColibri-ն աշխատում է Binance, Bybit, OKX և CME բորսաների հետ։ Դուք միացնում եք ձեր սեփական հաշիվը և պահում վերահսկողությունը. մենք միջոցներ չենք վերցնում կառավարման և չունենք դուրսբերման իրավունք։',
        bannerNote: 'Միացումն անվճար է։ Միջնորդավճար՝ միայն շահութաբեր գործարքներից։',
        videoLinks: [
            'https://www.youtube.com/embed/inD4zz_SQXY',
            'https://www.youtube.com/embed/RP_65yzdvEg',
            'https://www.youtube.com/embed/jNB877YciUs',
            'https://www.youtube.com/embed/uOR5tPkncXM',
        ],
    },
    de: {
        bannerEyebrow: 'Ein komplettes System für automatisierten Handel',
        bannerSecondary: 'So funktioniert es',
        bannerTitles: [
            'Automatisierter Futures-Handel auf Ihrem eigenen Börsenkonto',
            'Ihr Konto, Ihr Geld, Ihre Regeln. Das System arbeitet für Sie',
            'Wir verwalten keine fremden Konten. Wir entwickeln das Werkzeug',
            'Ihre gesamte Handelsautomatisierung in einem System',
            'Sie starten es, Sie stoppen es. Das System führt aus',
            'Futures-Handel rund um die Uhr, ohne Auszahlungszugriff',
            'Ein Werkzeug für Trader, keine Vermögensverwaltung',
            'Wir entwickeln das System weiter. Sie handeln',
        ],
        bannerText:
            'RealColibri arbeitet mit Binance, Bybit, OKX und der CME. Sie verbinden Ihr eigenes Konto und behalten die Kontrolle: Wir verwalten keine Gelder und haben kein Auszahlungsrecht.',
        bannerNote: 'Kostenlos verbinden. Provision nur auf profitable Trades.',
        videoLinks: [
            'https://youtube.com/embed/ao6VNdpuQWY',
            'https://www.youtube.com/embed/s6V-6J5qBhY',
            'https://www.youtube.com/embed/hMTmc8n-W1A',
            'https://youtube.com/embed/F32rYFgPjE4',
        ],
    },
    fr: {
        bannerEyebrow: 'Un système complet d’automatisation du trading',
        bannerSecondary: 'Comment ça marche',
        bannerTitles: [
            'Trading automatisé de futures sur votre propre compte d’exchange',
            'Votre compte, votre argent, vos règles. Le système travaille pour vous',
            'Nous ne gérons pas les comptes des autres. Nous créons l’outil',
            'Toute l’automatisation de votre trading dans un seul système',
            'Vous le lancez, vous l’arrêtez. Le système exécute',
            'Trading de futures 24 h/24, sans accès aux retraits',
            'Un outil pour les traders, pas de la gestion d’actifs',
            'Nous développons le système. C’est vous qui tradez',
        ],
        bannerText:
            'RealColibri fonctionne avec Binance, Bybit, OKX et le CME. Vous connectez votre propre compte et gardez le contrôle : nous ne gérons aucun fonds et n’avons aucun droit de retrait.',
        bannerNote: 'Connexion gratuite. Commission uniquement sur les trades gagnants.',
        videoLinks: [
            'https://youtube.com/embed/LdDoaNMvYbQ',
            'https://www.youtube.com/embed/A8lbpRDIvHE',
            'https://youtube.com/embed/bFDE301F6NY',
            'https://www.youtube.com/embed/sxI2IEdueoc',
        ],
    },
    it: {
        bannerEyebrow: 'Un sistema completo per l’automazione del trading',
        bannerSecondary: 'Come funziona',
        bannerTitles: [
            'Trading automatico di futures sul tuo conto di exchange',
            'Il tuo conto, i tuoi soldi, le tue regole. Il sistema lavora per te',
            'Non gestiamo i conti degli altri. Costruiamo lo strumento',
            'Tutta l’automazione del tuo trading in un unico sistema',
            'Lo avvii e lo fermi tu. Il sistema esegue',
            'Trading di futures 24/7, senza accesso ai prelievi',
            'Uno strumento per trader, non una gestione patrimoniale',
            'Noi sviluppiamo il sistema. A fare trading sei tu',
        ],
        bannerText:
            'RealColibri funziona con Binance, Bybit, OKX e CME. Colleghi il tuo conto e mantieni il controllo: non prendiamo fondi in gestione e non abbiamo diritto di prelievo.',
        bannerNote: 'Collegamento gratuito. Commissione solo sulle operazioni in profitto.',
        videoLinks: [
            'https://www.youtube.com/embed/-uC9dkBwhuA?si=oHI_d2Z3otzqsANX',
            'https://www.youtube.com/embed/zK5-5x93oY0',
            'https://youtube.com/embed/eb6MiEFqg04',
            'https://www.youtube.com/embed/8OGdtvJZ-Q4?si=Resi7kvDZDBU4qYm',
        ],
    },
}

export const getTranslation = (language: string) =>
    translations[language as Language] || translations.en
